const themes = [
  {
    icon: "ri-book-2-line",
    title: "Financial Education",
    desc: "Building financial literacy, awareness, and capability across diaspora communities and emerging investor audiences.",
    color: "bg-[#1A4D3C]",
  },
  {
    icon: "ri-global-line",
    title: "Diaspora Engagement",
    desc: "Connecting the global African Diaspora with credible platforms, structured opportunity, and long-term wealth-building pathways.",
    color: "bg-[#C9A961]",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "Investor Readiness",
    desc: "Equipping individuals and families with the knowledge, frameworks, and confidence to make informed, long-term investment decisions.",
    color: "bg-[#1A4D3C]",
  },
  {
    icon: "ri-user-star-line",
    title: "Advisory Support",
    desc: "Expanding access to structured, relationship-driven advisory services for diaspora professionals, families, and emerging investors.",
    color: "bg-[#C9A961]",
  },
  {
    icon: "ri-tools-line",
    title: "Workforce Development",
    desc: "Building professional capability, financial skills, and long-term economic participation within diaspora and local communities.",
    color: "bg-[#1A4D3C]",
  },
  {
    icon: "ri-exchange-line",
    title: "Cross-Border Opportunity",
    desc: "Creating structured pathways for diaspora capital, talent, and expertise to connect with African market opportunity.",
    color: "bg-[#C9A961]",
  },
];

export default function CollaborationThemes() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Featured Themes
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-5">
            Featured Collaboration Themes
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed">
            These are the core themes that shape our partnership conversations &mdash; areas where aligned collaboration creates the most meaningful, lasting impact.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {themes.map((theme) => (
            <div
              key={theme.title}
              className="group relative overflow-hidden rounded-lg border border-[#E8E4DC] hover:border-[#C9A961]/40 transition-all duration-300 cursor-default"
            >
              <div className="p-8">
                <div
                  className={`w-12 h-12 flex items-center justify-center rounded-full ${theme.color} mb-5`}
                >
                  <i className={`${theme.icon} text-white text-xl`} />
                </div>
                <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-3">
                  {theme.title}
                </h3>
                <p className="text-[#6B6B6B] text-sm leading-relaxed">{theme.desc}</p>
              </div>
              {/* Bottom accent bar */}
              <div
                className={`h-1 w-0 group-hover:w-full transition-all duration-500 ${theme.color}`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
